import React from "react";
import { Route, Routes } from "react-router-dom";
import LearnMore from "../components/clinician/dashboard/LearnMore";
export function LearnMoreRoute() {
    return (
        <Routes>
                <Route path="/learnmore"  element={<LearnMore />} />  
        </Routes>
    );
}